module.exports = __webpack_public_path__ + "img/@logo_orion@3x.4c8ac493.png";